var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "footer-subscribe",
      attrs: { action: _vm.action, method: "post" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.sendForm($event)
        }
      }
    },
    [
      _c("span", { staticClass: "footer-subscribe__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "div",
        { staticClass: "footer-subscribe__row" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mail,
                expression: "mail"
              }
            ],
            staticClass: "footer-subscribe__field",
            attrs: { type: "mail", required: "", placeholder: "Ваш e-mail" },
            domProps: { value: _vm.mail },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.mail = $event.target.value
              }
            }
          }),
          _c(
            "btn",
            {
              staticClass: "footer-subscribe__submit",
              attrs: { tag: "control" }
            },
            [_c("icon-angle", { attrs: { mod: "right" } })],
            1
          ),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.message
              ? _c(
                  "div",
                  { staticClass: "footer-subscribe__message" },
                  [
                    _vm._v("\n\t\t\t\t" + _vm._s(_vm.message) + "\n\n\t\t\t\t"),
                    _c(
                      "btn",
                      {
                        staticClass: "footer-subscribe__message-close",
                        attrs: { tag: "control", type: "button" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.closeMessage($event)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M12 .8l-.8-.8L6 5.2.8 0 0 .8 5.2 6 0 11.2l.8.8L6 6.8l5.2 5.2.8-.8L6.8 6z"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38defc38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38defc38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FooterSubscribe.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-38defc38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FooterSubscribe.vue
// module chunks = 5